import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import classNames from 'classnames';
import { ContentType, LessonMode, QuestionFeedbackState } from '../../Constants';
import { register } from '../../i18n';
import HtmlComponent from './HtmlComponent';
import responseService from '../services/ResponseService';
import HintDialog from './HintDialog';
import SolutionDialog from './SolutionDialog';

import '../../css/QuestionFeedback.scss';
import UtilsService from '../services/UtilsService';

const t = register('GlobalQuestionLabels');

const QuestionFeedback = observer((props) => {
  const { lessonElementId, isSurvey } = props;

  const {
    lessonManager,
    responseManager,
    questionFeedbackManager
  } = useContext(MobXProviderContext);

  const lessonElementState = responseManager.getLessonElementState(lessonElementId);

  const model = lessonManager.getSlideModel(lessonElementId);

  const uiState = questionFeedbackManager.getUiState(lessonElementId);

  const showAnswers = (uiState) ? uiState.showAnswers : false;
  let showQuestionFeedback = (uiState) ? uiState.showQuestionFeedback : false;
  const feedBackString = responseService.getQuestionFeedbackText(lessonElementId);
  if (UtilsService.isNullOrEmpty(feedBackString)) {
    showQuestionFeedback = false;
  }

  const isCorrect = (lessonElementState && lessonElementState.correctAnswerShowing) ? QuestionFeedbackState.CORRECT : responseManager.isQuestionCorrect(lessonElementId);
  // TODO unused // const status = (studentActivityManager && studentActivityManager.activityInstanceStatus)?studentActivityManager.activityInstanceStatus:ActivityStatus.ACTIVITY_STARTED;
  const { hasFeedback } = questionFeedbackManager;
  const mode = lessonManager.playerMode;
  const isAuto = (responseService.isAutoScored(lessonElementId));
  const showAnswerText = responseService.getShowAnswerText(lessonElementId);
  const { noSubmit } = questionFeedbackManager;

  return (
    <>
      {(lessonElementState && lessonElementState.isTestItem ) ? (
        <div className={classNames('question-feedback theme-container', { 'is-survey': isSurvey })}>
          {(showAnswers && showAnswerText) && (
            <div className='accepted-answers-feedback' aria-live='polite' aria-atomic='true' >
              <div className='accepted-answers-feedback-heading'>
                {t('acceptedAnswers')}
              </div>
              <HtmlComponent htmlStr={showAnswerText} />
            </div>
          )}
          {((showQuestionFeedback && hasFeedback) || (mode === LessonMode.REVIEW)) && (
            <div className={classNames({
              'question-feedback-wrapper': true,
              'correct': (isCorrect === QuestionFeedbackState.CORRECT && (isAuto) && model.type !== ContentType.LIKERT.type),
              'incorrect': ((isCorrect === QuestionFeedbackState.INCORRECT || isCorrect === QuestionFeedbackState.PARTIAL_CORRECT)
                && model.type !== ContentType.LIKERT.type
                && (isAuto))

            })} aria-live='polite' aria-atomic='true' aria-label={feedBackString}>
              <HtmlComponent htmlStr={feedBackString} />
            </div>
          )}
          {(showQuestionFeedback && !hasFeedback && !noSubmit && mode !== LessonMode.REVIEW) && (
            <div className='question-feedback-wrapper' aria-live='polite' aria-atomic='true' aria-label={feedBackString}>
              <HtmlComponent htmlStr={feedBackString} />
            </div>
          )}
        </div>
      )
        : <div className='question-feedback theme-container' />}
      {questionFeedbackManager.openHintDialog && <HintDialog lessonElementId={lessonElementId} />}
      {questionFeedbackManager.openSolutionDialog && <SolutionDialog lessonElementId={lessonElementId} />}
    </>
  );
});

export default QuestionFeedback;
